import { useEffect } from "react";
import { resolveMedia } from "./api";

function setMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function useSEO(title, description, image) {
  useEffect(() => {
    document.title = title ? `${title} — Queen Denae` : "Queen Denae — Soul. Story. Style. No Permission Required.";
    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:description", description);
    }
    setMeta("property", "og:title", title ? `${title} — Queen Denae` : "Queen Denae");
    setMeta("property", "og:site_name", "Queen Denae");
    setMeta("property", "og:type", "website");
    setMeta("property", "og:url", window.location.href);
    if (image) {
      setMeta("property", "og:image", resolveMedia(image));
      setMeta("name", "twitter:card", "summary_large_image");
      setMeta("name", "twitter:image", resolveMedia(image));
    }
  }, [title, description, image]);
}
